import { Routes, Route, Navigate } from 'react-router-dom';
import RequireAdmin from '@/auth/RequireAdmin';
import AppLayout from '@/layout/AppLayout';
import LoginPage from '@/features/auth/LoginPage';
import DashboardPage from '@/features/dashboard/DashboardPage';
import BetaAllowlistPage from '@/features/betaAllowlist/BetaAllowlistPage';
import VideosPage from '@/features/videos/VideosPage';
import StripePage from '@/features/stripe/StripePage';
import UsersPage from '@/features/users/UsersPage';
import Placeholder from '@/components/ui/Placeholder';

const App = () => (
  <Routes>
    <Route path="/login" element={<LoginPage />} />

    <Route element={<RequireAdmin />}>
      <Route element={<AppLayout />}>
        <Route index element={<DashboardPage />} />
        <Route path="/users" element={<UsersPage />} />
        <Route path="/plans" element={<Placeholder title="Plans" />} />
        <Route path="/plans/create" element={<Placeholder title="Créer un plan" />} />
        <Route path="/plans/edit/:uuid" element={<Placeholder title="Éditer le plan" />} />
        <Route path="/plans/view/:uuid" element={<Placeholder title="Aperçu du plan" />} />
        <Route path="/plans/view/:uuid/:week" element={<Placeholder title="Aperçu du plan" />} />
        <Route path="/videos" element={<VideosPage />} />
        <Route path="/stripe" element={<StripePage />} />
        <Route path="/beta-allowlist" element={<BetaAllowlistPage />} />
      </Route>
    </Route>

    <Route path="*" element={<Navigate to="/" replace />} />
  </Routes>
);

export default App;
